import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__blob hero__blob--1" aria-hidden="true" />
      <div className="hero__blob hero__blob--2" aria-hidden="true" />

      <div className="container hero__inner">
        <div className="hero__content">
          <span className="hero__eyebrow">Regulatory &middot; Bioequivalence &middot; Pharmacovigilance</span>
          <h1 className="hero__title">
            Accelerating Compliant
            <br />
            Product Development
          </h1>
          <p className="hero__subtitle">
            Shrekruthi Phytoceuticals delivers integrated pharmaceutical,
            nutraceutical and Ayurvedic development and regulatory solutions —
            helping companies move faster while staying compliant with global
            regulatory standards.
          </p>
          <div className="hero__actions">
            <a href="#contact" className="btn btn-primary">
              Contact Us
            </a>
            <a href="#services" className="btn btn-outline">
              Explore Services
            </a>
          </div>
        </div>

        <div className="hero__visual" aria-hidden="true">
          <div className="hero__ring hero__ring--outer" />
          <div className="hero__ring hero__ring--inner" />
          <svg className="hero__leaf" viewBox="0 0 64 64" fill="none">
            <path
              d="M32 4C18 10 8 24 8 38c0 12 10 22 24 22s24-10 24-22C56 24 46 10 32 4Z"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path d="M32 8v52" stroke="currentColor" strokeWidth="2" />
          </svg>
        </div>
      </div>
    </section>
  );
}

export default Hero;
